"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _classnames = _interopRequireDefault(require("classnames"));

var _isMemoizePropsEqual = _interopRequireDefault(require("../utils/isMemoizePropsEqual"));

var _aspectRatioHeights = _interopRequireDefault(require("../../../../../constants/aspectRatioHeights"));

function ShotImage(_ref) {
  var isOver = _ref.isOver,
      connectDropTarget = _ref.connectDropTarget,
      asset = _ref.asset,
      aspectRatio = _ref.aspectRatio;

  var _ref2 = asset || {},
      _ref2$assetFiles = _ref2.assetFiles;

  _ref2$assetFiles = _ref2$assetFiles === void 0 ? {} : _ref2$assetFiles;
  var _ref2$assetFiles$ORIG = _ref2$assetFiles.ORIGINAL;
  _ref2$assetFiles$ORIG = _ref2$assetFiles$ORIG === void 0 ? {} : _ref2$assetFiles$ORIG;
  var _ref2$assetFiles$ORIG2 = _ref2$assetFiles$ORIG.sourceUrl,
      sourceUrl = _ref2$assetFiles$ORIG2 === void 0 ? '' : _ref2$assetFiles$ORIG2;
  return connectDropTarget(_react.default.createElement("div", {
    className: (0, _classnames.default)('shot__image__container', {
      'shot__image-hovered': isOver
    }),
    style: {
      height: "".concat(_aspectRatioHeights.default[aspectRatio], "px")
    }
  }, _react.default.createElement(_uiKit.Image, {
    height: "100%",
    width: "100%",
    imageUrl: sourceUrl,
    defaultIconBackground: "white",
    defaultImageIcon: asset === null ? 'brokenlink' : 'storyboard',
    defaultIconColour: "russian",
    backgroundSize: "cover"
  })));
}

var _default = (0, _react.memo)(ShotImage, _isMemoizePropsEqual.default);

exports.default = _default;